import { useQuery } from "@tanstack/react-query";
import { PermissionService } from "../../../services/permission/permission.service";
import { useSearchParams } from "../../../hook/use-search-params";
import { getListIdByStatusValue } from "../../../services/serviceHelper";

export const useFilePermission = () => {
  const { searchParams } = useSearchParams();
  const fileId = searchParams.get("fileId") || "";
  const status = searchParams.get("status") || "";
  const listId = getListIdByStatusValue(status, false);

  const { data, isLoading } = useQuery({
    queryKey: ["file-permission", fileId],
    queryFn: () => PermissionService.getDocumentPermissons(fileId, listId),
    select: (res) => res.data,
    enabled: !!fileId && status !== "publish",
  });

  return { data, isLoading };
};
